import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Users } from 'lucide-react';

const INCLUDED = [
    'Marcação com hora real e geolocalização',
    'Assinatura digital em cada registro',
    'Exportação mensal para a contabilidade',
    'Relatórios imutáveis para auditoria',
    'Histórico por colaborador',
];

const OfertaPontoSection = () => (
    <section id="oferta" className="scroll-mt-20 bg-slate-50 py-16 dark:bg-slate-900 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.45 }}
                className="mx-auto max-w-lg"
            >
                <article className="overflow-hidden rounded-3xl border border-emerald-200 bg-white shadow-xl shadow-emerald-950/5 dark:border-emerald-500/30 dark:bg-slate-950">
                    <div className="bg-emerald-500 px-6 py-3 text-center text-xs font-bold uppercase tracking-[0.16em] text-white">
                        Plano Padrão
                    </div>

                    <div className="px-6 py-8 sm:px-8">
                        <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                            Módulo de Registro de Ponto
                        </p>
                        <div className="mt-3 flex items-end gap-2">
                            <p className="text-5xl font-black tracking-tight text-slate-900 dark:text-white">
                                R$ 19,90
                            </p>
                            <p className="mb-1 text-base font-semibold text-slate-500 dark:text-slate-400">
                                / mês
                            </p>
                        </div>
                        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                            por usuário ativo do módulo
                        </p>

                        <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-4 dark:border-emerald-500/30 dark:bg-emerald-500/10">
                            <div className="flex items-start gap-3">
                                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white">
                                    <Users className="h-4 w-4" />
                                </span>
                                <p className="text-sm font-semibold leading-relaxed text-emerald-900 dark:text-emerald-100">
                                    Acima de 30 usuários: apenas R$ 17,90 por usuário/mês!
                                </p>
                            </div>
                        </div>

                        <ul className="mt-6 space-y-3">
                            {INCLUDED.map((item) => (
                                <li key={item} className="flex items-start gap-3 text-sm text-slate-700 dark:text-slate-200">
                                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-8 flex flex-col gap-3">
                            <Link
                                to="/demonstracao"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-6 py-3.5 text-base font-semibold text-white shadow-lg transition duration-300 hover:-translate-y-0.5 hover:bg-emerald-600 hover:shadow-emerald-500/20"
                            >
                                Solicitar Demonstração
                                <ArrowRight className="h-4 w-4" />
                            </Link>
                        </div>
                    </div>
                </article>
            </motion.div>
        </div>
    </section>
);

export default OfertaPontoSection;
